export enum GregorioLiquescentia {
  NO_LIQUESCENTIA = 0x00,
  DEMINUTUS = 0x01,
  AUCTUS_ASCENDENS = 0x02,
  AUCTUS_DESCENDENS = 0x04,
  INITIO_DEBILIS = 0x10,
  DEMINUTUS_INITIO_DEBILIS = 0x11,
  AUCTUS_ASCENDENS_INITIO_DEBILIS = 0x12,
  AUCTUS_DESCENDENS_INITIO_DEBILIS = 0x14,
  FUSED = 0x20,
  FUSED_DEMINUTUS = 0x21,
  FUSED_AUCTUS_ASCENDENS = 0x22,
  FUSED_AUCTUS_DESCENDENS = 0x24,
}

export const TAIL_LIQUESCENTIA_MASK = 0x07;
